import { Store } from '.';

export enum CopilotDisplayMode {
  UnhelpfulFeedback = 'UnhelpfulFeedback',
  CopilotMainView = 'CopilotMainView',
  Chatbot = 'Chatbot',
  Loading = 'Loading',
}

export enum ChatbotFlow {
  REGULAR = 'regular_flow',
  CONTACT = 'contact_flow',
}

export type CopilotSlice = {
  copilotDisplayMode: CopilotDisplayMode;
  isChatbotInitializing: boolean;
  isChatbotReady: boolean;
  chatbotReferral: string | null;
  chatbotFlow: ChatbotFlow;
  setCopilotDisplayMode: (displayMode: CopilotDisplayMode) => void;
  setIsChatbotInitializing: (isChatbotInitializing: boolean) => void;
  setIsChatbotReady: (isChatbotReady: boolean) => void;
  setChatbotReferral: (referral: string | null) => void;
  setChatbotFlow: (flow: ChatbotFlow) => void;
};

export const getCopilotInitialState =
  (set: (stateUpdater: (state: Store) => Partial<Store>) => void): CopilotSlice => ({
    copilotDisplayMode: CopilotDisplayMode.CopilotMainView,
    isChatbotInitializing: false,
    isChatbotReady: false,
    chatbotReferral: null,
    chatbotFlow: ChatbotFlow.REGULAR,
    setCopilotDisplayMode: (copilotDisplayMode: CopilotDisplayMode) => {
      set((state: Store) => ({
        copilotSlice: {
          ...state.copilotSlice,
          copilotDisplayMode,
        },
      }));
    },
    setIsChatbotInitializing: (isChatbotInitializing: boolean) => {
      set((state: Store) => ({
        copilotSlice: {
          ...state.copilotSlice,
          isChatbotInitializing,
          copilotDisplayMode: CopilotDisplayMode.Loading,
        },
      }));
    },
    setIsChatbotReady: (isChatbotReady: boolean) => {
      set((state: Store) => ({
        copilotSlice: {
          ...state.copilotSlice,
          isChatbotReady,
          isChatbotInitializing: false,
        },
      }));
    },
    setChatbotReferral: (chatbotReferral: string | null) => {
      set((state: Store) => ({
        copilotSlice: {
          ...state.copilotSlice,
          chatbotReferral,
        },
      }));
    },
    setChatbotFlow: (chatbotFlow: ChatbotFlow) => {
      set((state: Store) => ({
        copilotSlice: {
          ...state.copilotSlice,
          chatbotFlow,
        },
      }));
    }
  });
